import { List, styles } from "./List";
import { Pagination } from "./Pagination";

const LessonTable = ({ data = [] }) => {
  return (
    <div style={styles.container}>
      <table style={styles.table}>
        <thead>
          <tr>
            <th style={styles.th}>Board</th>
            <th style={styles.th}>Grade</th>
            <th style={styles.th}>Section/Period</th>
            <th style={styles.th}>Subject</th>
            <th style={styles.th}>Topic</th>
            <th style={styles.th}>Status</th>
            <th style={styles.th}>Created</th>
          </tr>
        </thead>

        <tbody>
          {data.map((item) => {

            const status = item.current_stage === "Instructional Framework Builder"?"completed":"incomplete";

            return <tr key={item.id} style={styles.tr}>
              <td style={styles.td}>{item.board?.name}</td>
              <td style={styles.td}>{item.grade?.name}</td>
              <td style={styles.td}>{item.section}</td>
              <td style={styles.td}>{item.subject?.name }</td>
              <td style={styles.td}>{item.topic || "Untitled"}</td>
              <td style={styles.td}>
                <span style={{...styles.status,...styles[status]}}>{status}</span>
              </td>
              <td style={styles.td}>
                {new Date(item.created_at).toLocaleDateString()}
              </td>
            </tr>
})}
        </tbody>
      </table>
    </div>
  );
};

export default LessonTable;

export function LessonPlanList({
  loading,
  error,
  message,
  list,
  pagination,
  className = "",
  onPageChange
}) {
  return (
    <List
      className={className}
      loading={loading}
      error={error}
      message={message}
    >
      <LessonTable data={list} />
      {pagination ? <Pagination {...pagination} onPageChange={onPageChange}/>:null}
    </List>
  );
}
